module.exports = __webpack_public_path__ + "media/images/seth-doyle-2-390060504cc19b8042f346f476a6d568.png";